import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-46a950d6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "notification-title"
}, "请输入验证码", -1));

const _hoisted_3 = {
  class: "notification-phone"
};
const _hoisted_4 = {
  class: "notification-field"
};
const _hoisted_5 = {
  class: "count-down"
};
const _hoisted_6 = {
  key: 1
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交");

const _hoisted_8 = {
  class: "notification-information"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("验证码用于校验，请放心输入！");

const _hoisted_10 = {
  key: 1
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "notification-title"
}, "提示", -1));

const _hoisted_12 = {
  class: "center mt-60-mb-30"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "notification-text"
}, "线索提交成功！", -1));

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "notification-center-p"
}, "查看后续线索进展，请在微信小程序 ", -1));

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "notification-center-p mb-68"
}, [/*#__PURE__*/_createElementVNode("span", null, "“机惠宝”"), /*#__PURE__*/_createTextVNode(" 中查看详情。")], -1));

const _hoisted_16 = /*#__PURE__*/_createTextVNode("我知道了");

import { getClueSaveSendCode } from '@/api';
import { ref, onMounted, watch } from 'vue';
import { second } from './type'; // import { RecomFace } from '../type';

export default /*#__PURE__*/_defineComponent({
  __name: 'VerifiCationOpen',
  props: {
    show: {
      type: Boolean
    },
    phone: {
      type: String,
      required: false,
      default: ''
    },
    notifiShow: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['close', 'confirm'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const verificationgbCode = ref('');
    const verificationgbPhone = ref('');
    const verifiTime = ref(second.meter);
    onMounted(() => {
      verificationgbCode.value = props.phone;
      countDown();
    }); // 监听show的变化为true执行

    watch(() => props.show, value => {
      if (value) {
        verificationgbCode.value = props.phone;

        if (verifiTime.value <= 0) {
          countDown();
        }
      }
    }); // 倒计时事件

    const countDown = async () => {
      if (verifiTime.value >= second.meter) {
        const res = await getClueSaveSendCode({
          phone: verificationgbCode.value
        });

        if (res.code === 200) {
          _Toast.success('验证码发送成功');
        } else {
          _Toast('验证码发送失败');
        }
      }

      const timer = setInterval(() => {
        if (verifiTime.value >= 1) {
          verifiTime.value--;
        }

        if (verifiTime.value <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    }; // 重新获取验证码并且触发倒计时


    const reacquire = () => {
      verifiTime.value = second.meter;
      countDown();
    };

    const close = () => {
      emits('close');
    };

    const submit = () => {
      if (verificationgbPhone.value) {
        emits('confirm', verificationgbPhone.value);
      } else {
        _Toast('请输入正确的验证码');
      }
    }; // watch(
    //   () => props.notifiShow,
    //   () => {}
    // );


    const onGotit = () => {
      verificationgbPhone.value = '';
      emits('close');
    };

    return (_ctx, _cache) => {
      const _component_icon_payment_verificationgb = _resolveComponent("icon-payment-verificationgb");

      const _component_van_field = _resolveComponent("van-field");

      const _component_van_button = _resolveComponent("van-button");

      const _component_icon_payment_verificationjg = _resolveComponent("icon-payment-verificationjg");

      const _component_icon_payment_complete = _resolveComponent("icon-payment-complete");

      return _openBlock(), _createElementBlock("div", {
        class: "pop-up-notification",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [_createVNode(_component_icon_payment_verificationgb, {
        class: "icon-gb",
        onClick: close
      }), !__props.notifiShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", _hoisted_3, "已发送验证码到：" + _toDisplayString(verificationgbCode.value), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_field, {
        modelValue: verificationgbPhone.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => verificationgbPhone.value = $event),
        type: "digit",
        placeholder: "请输入验证码"
      }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [verifiTime.value <= 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "count-down-text",
        onClick: reacquire
      }, "重新获取")) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(verifiTime.value) + "S", 1))])]), _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        color: "linear-gradient(to left,#FD002B, #FF6400)",
        onClick: submit
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }), _createElementVNode("p", _hoisted_8, [_createVNode(_component_icon_payment_verificationjg, {
        class: "icon-jg"
      }), _hoisted_9])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_icon_payment_complete, {
        class: "icon-lete"
      }), _hoisted_13]), _hoisted_14, _hoisted_15, _createVNode(_component_van_button, {
        type: "primary",
        block: "",
        color: "linear-gradient(to left,#FD002B, #FF6400)",
        onClick: onGotit
      }, {
        default: _withCtx(() => [_hoisted_16]),
        _: 1
      })]))]);
    };
  }

});